module.exports = __webpack_public_path__ + "static/the-great-crash-1929-8db124831f890448d510cc2a6674e718.jpg";